import styled from 'styled-components';

export const MainLinksTitle = styled.p`
  ${(props) => props.theme.typography.subHeader};
  color: ${(props) => props.theme.colors.text};
  margin-bottom: 4px;
`;

export const MainLinksSubtitle = styled.p`
  font-size: 13px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.disabled};
  margin-bottom: 16px;
`;

export const MainLinksWrapper = styled.div`
  min-width: 230px;
`;

export const LinkRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  :last-child {
    margin-bottom: 0;
  }
`;

export const WrappedIcon = styled.div`
  display: inline-block;
  color: ${(props) => props.theme.colors.brand};
`;

export const LinkHeader = styled.a`
  display: inline-block;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.brand};
  font-weight: 700;
  margin-left: 8px;
`;
